import { render, staticRenderFns } from "./NoGroupMember.vue?vue&type=template&id=240781c2&scoped=true&"
import script from "./NoGroupMember.vue?vue&type=script&lang=js&"
export * from "./NoGroupMember.vue?vue&type=script&lang=js&"
import style0 from "./NoGroupMember.vue?vue&type=style&index=0&id=240781c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240781c2",
  null
  
)

export default component.exports